<template>
  <section class="direct_debit-comp">
    <div>
      <h1>Set Global Direct Debit Rules</h1>
      <div class="direct_debit-comp__configuration">
        <Dropdown
          title="Transaction Limit"
          label="Select Limit Type"
          :options="state.configType"
          :onOptionSelected="({ id }) => (state.selected.config_type = id)"
        />
        <Input
          label="Value"
          :onChange="(value) => (state.selected.value = value)"
        />
        <Dropdown
          title="Resource"
          label="Select Resource Category"
          :options="state.categories"
          :onOptionSelected="({ id }) => (state.selected.category_id = id)"
        />
        <Dropdown
          title="Period"
          label="Daily"
          :options="state.frequency"
          :onOptionSelected="({ id }) => (state.selected.frequency = id)"
        />
        <div>
          <Button
            buttonName="Add Rule"
            classes="primary"
            :disabled="!validateSelected() || state.disableButton"
            :onClick="addRule"
          />
        </div>
      </div>
      <div></div>
    </div>
    <Table
      :contents="contents.rules"
      :hideTableTop="true"
      :pageInfo="contents.page_info"
      :onPageChange="onPageChange"
      :loading="contents.loading"
      :hidePagination="true"
      :noClickEvent="true"
      :displayId="false"
    >
      <template v-slot:empty="slotProps">
        <router-link
          class=""
          tag="div"
          :to="{
            name: 'global-direct-debit-edit-rule',
            params: { itemId: slotProps.item.id },
          }"
        >
          <Button buttonName="Edit" classes="grey" :onClick="() => {}" />
        </router-link>
      </template>
    </Table>
  </section>
</template>
<script>
import Vue from "vue";
import Dropdown from "@/components/dropdown";
import Input from "@/components/input";
import Button from "@/components/button";
import Table from "@/components/table";
import { reactive, computed, onBeforeMount, watch } from "@vue/composition-api";
export default {
  name: "DirectDebit",
  setup(props, { root }) {
    const store = root.$store;
    const state = reactive({
      configType: [
        { value: "Transaction Volume", id: "transaction_volume" },
        { value: "Transaction Value", id: "transaction_value" },
        { value: "Transaction Attempt", id: "transaction_attempts" },
      ],
      categories: [
        { value: "Per Merchant", id: 1 },
        { value: "Per Customer", id: 2 },
      ],
      frequency: [
        { value: "Daily", id: "DAILY" },
        { value: "Weekly", id: "WEEKLY" },
        { value: "Monthly", id: "MONTHLY" },
      ],
      selected: {
        config_type: "",
        value: "",
        frequency: "DAILY",
        category_id: "",
      },
      isFormValid: false,
      disableButton: false,
    });
    onBeforeMount(() => {
      store.dispatch("getDirectDebitRules");
    });
    watch(
      () => root.$route.query,
      () => {
        store.dispatch("getDirectDebitRules", { ...root.$route.query });
      }
    );
    const validateSelected = () => {
      let isValid = true;
      Object.values(state.selected).map((value) => {
        if (value == "") isValid = false;
      });
      return isValid;
    };
    const contents = computed(() => store.getters.getDirectDebitRulesGlobal);
    const handleExportDownload = () => {};
    const onPageChange = () => {};
    const addRule = async () => {
      try {
        state.disableButton = true;
        const res = await Vue.http.post(
          `${process.env.VUE_APP_DD_API_URL}/admin/mandates/config/limit`,
          state.selected
        );
        state.disableButton = false;
        store.dispatch("getDirectDebitRules");
        Vue.notify({
          group: "notifications-default",
          type: "success text-white",
          title: "Rule created",
          text: res.body.message,
        });
      } catch (err) {
        state.disableButton = false;
        Vue.notify({
          group: "notifications-default",
          type: "error text-white",
          title: "Error",
          text: err.body.message,
        });
      }
    };
    const handleEditRedirect = () => {
      root.$router.push({ name: "settings" });
    };
    return {
      state,
      handleExportDownload,
      onPageChange,
      contents,
      validateSelected,
      addRule,
      handleEditRedirect,
    };
  },
  components: {
    Dropdown,
    Input,
    Button,
    Table,
  },
};
</script>
<style lang="scss">
.direct_debit-comp {
  > div:first-child {
    padding: 0 25px 25px;
  }
  h1 {
    font-style: italic;
    font-weight: normal;
    font-size: 18px;
    line-height: 22px;
    color: #261940;
    margin: 10px 25px 50px;
  }

  .custom-input  {
      input {
        border: none !important;
      }
  }
  
  .table-component {
    margin: 0;
    border: none;
    margin-bottom: 160px;
    box-shadow: none;
    width: 100%;
    .button-comp {
      display: flex;
      justify-content: center;
    }
    table {
      tbody {
        td {
          max-width: 160px;
        }
      }
    }
    .btn {
      width: 70px;
      justify-content: center;
      padding: 10px 0;
      .btn--text {
        font-size: 14px;
      }
    }
  }
  .form__input {
    border: none !important;
  }
  &__configuration {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    margin-bottom: 20px;
    justify-content: flex-end;
     
    .btn {
      height: 50px;
    }
    .form__item {
      margin-bottom: 15px;
    }
    > div {
      margin-right: 15px;
      margin-bottom: 15px;
    }
  }
}
.drop-down {
  svg {
    margin-left: 20px;
  }

  height: 59px;
  position: relative;
    min-width: 220px;
}
.dropdown-options {
  width: 100%;
}
</style>